<script lang="ts">
	import { page } from '$app/state';
	import ErrorLayout from '$lib/components/layout/ErrorLayout.svelte';
	import type { Market } from '$lib/types/market';
	import type { User } from '$lib/types/user';

	let { data = { market: null, user: null, loggedIn: false } } = $props<{
		data?: {
			market?: Market | null;
			user?: User | null;
			loggedIn?: boolean;
		};
	}>();

	// Define error configurations for each error type
	const errorConfigs = {
		404: {
			theme: 'Empty Stall',
			imageSrc: '/images/errors/404.png',
			imageAlt: 'An empty stall at a deserted farmers market with a GONE FISHING sign.',
			caption: 'Oops! This stall is empty—just like this page. Maybe try another aisle?',
			placeholder: false,
		},
		500: {
			theme: 'Spilled Berries',
			imageSrc: '/images/placeholders/500.png',
			imageAlt: 'A crate of spilled berries and a mischievous goat.',
			caption:
				"Yikes! Something spilled in the system. We're picking up the mess as fast as we can.",
			placeholder: true,
		},
		403: {
			theme: 'Members Only Root Cellar',
			imageSrc: '/images/placeholders/403.png',
			imageAlt: "A locked cellar door with a handmade 'Members Only' sign.",
			caption:
				'Looks like this root cellar is for growers only. If you think you should be here, let us know.',
			placeholder: true,
		},
		401: {
			theme: 'Missing Market Badge',
			imageSrc: '/images/placeholders/401.png',
			imageAlt: 'A farmers market entrance asking for credentials.',
			caption: "You need a vendor badge or customer pass to get in. Let's check your credentials.",
			placeholder: true,
		},
		502: {
			theme: 'Broken Wheelbarrow',
			imageSrc: '/images/placeholders/502.png',
			imageAlt: 'A broken wheelbarrow and scattered vegetables.',
			caption: "Our cart took a wrong turn on the way to the server. We'll fix it up soon!",
			placeholder: true,
		},
	};

	// Get error status and fallback to 500
	const errorStatus = page.status || 500;
	const config = errorConfigs[errorStatus as keyof typeof errorConfigs] || errorConfigs[500];
</script>

<div data-error="true">
	<ErrorLayout
		errorCode={errorStatus.toString()}
		theme={config.theme}
		imageSrc={config.imageSrc}
		imageAlt={config.imageAlt}
		caption={config.caption}
		showHomeButton={true}
		showBackButton={true}
		market={data?.market || null}
		user={data?.user || null}
		loggedIn={data?.loggedIn || false}
		placeholder={config.placeholder}
	/>
</div>
